var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRectangle31BSelected = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 35",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M13.009 7a6 6 0 1 1-12 0 6 6 0 0 1 12 0Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M10.544 3.465a5 5 0 0 0-7.07 0A1 1 0 0 1 2.058 2.05a7 7 0 0 1 9.9 0 1 1 0 1 1-1.415 1.415Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M30.009 7a6 6 0 1 1-12 0 6 6 0 0 1 12 0Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M27.544 3.465a5 5 0 0 0-7.07 0 1 1 0 0 1-1.415-1.415 7 7 0 0 1 9.9 0 1 1 0 1 1-1.415 1.415Z",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M47.009 7a6 6 0 1 1-12 0 6 6 0 0 1 12 0Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M44.544 3.465a5 5 0 0 0-7.07 0 1 1 0 0 1-1.415-1.415 7 7 0 0 1 9.9 0 1 1 0 1 1-1.415 1.415Z",
  clipRule: "evenodd"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M.001 17.5a2.5 2.5 0 0 1 2.5-2.5h43a2.5 2.5 0 0 1 2.5 2.5v15a2.5 2.5 0 0 1-2.5 2.5h-43a2.5 2.5 0 0 1-2.5-2.5v-15Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M45.501 17h-43a.5.5 0 0 0-.5.5v15a.5.5 0 0 0 .5.5h43a.5.5 0 0 0 .5-.5v-15a.5.5 0 0 0-.5-.5Zm-43-2a2.5 2.5 0 0 0-2.5 2.5v15a2.5 2.5 0 0 0 2.5 2.5h43a2.5 2.5 0 0 0 2.5-2.5v-15a2.5 2.5 0 0 0-2.5-2.5h-43Z",
  clipRule: "evenodd"
})));
SvgRectangle31BSelected.viewBox = '0 0 48 35';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRectangle31BSelected);
export default ForwardRef;